module.exports = __webpack_public_path__ + "static/media/Maax-Bold.6696b2bb.svg";